import { Link } from "react-router";
function Terms() {
    return (
        <div className="flex h-full px-4 pt-6 pb-24 md:px-10">
            <div className="container mx-auto md:pt-15">
                <article className="mx-auto prose max-w-4xl prose-darkgreen">
                    <p className="text-center text-sm font-medium tracking-[0.32em] text-neutral-400 uppercase">
                        LEGAL
                    </p>

                    <h1 className="mb-4 text-center text-6xl font-semibold tracking-wider">
                        Terms & conditions.
                    </h1>

                    <p className="lead mx-auto max-w-3xl text-center text-neutral-500">
                        The plain-English version of how Welnido works for
                        patients and clinicians.
                    </p>

                    <h2 id="who-we-are" className="text-2xl">
                        1. Who we are
                    </h2>

                    <p>
                        Welnido Limited ("Welnido", "we") operates an online
                        platform connecting patients with independent private
                        clinicians in the UK. Welnido is a booking platform:
                        clinicians on Welnido are independent professionals
                        responsible for the care they provide.
                    </p>

                    <h2 id="using-welnido-patient" className="text-2xl">
                        2. Using Welnido as a patient
                    </h2>

                    <p>
                        Searching and booking on Welnido is free for patients.
                        You pay the clinician's own fees for appointments.
                        Bookings are made directly with the clinician;
                        cancellation terms are shown before you confirm. Welnido
                        does not provide medical advice — in an emergency always
                        call 999 or contact NHS 111.
                    </p>

                    <h2 id="using-welnido-clinician" className="text-2xl">
                        3. Using Welnido as a clinician
                    </h2>

                    <p>
                        Clinicians must hold and maintain valid professional
                        registration, an enhanced DBS check and appropriate
                        indemnity insurance at all times. Fees comprise a
                        monthly subscription and a one-time fee for each new
                        patient introduced by Welnido; repeat bookings from the
                        same patient are never charged. Your first three months
                        are free.
                    </p>

                    <h2 id="verification" className="text-2xl">
                        4. Verification
                    </h2>

                    <p>
                        We verify clinician credentials at onboarding and
                        monitor registration status on an ongoing basis, as
                        described in our{" "}
                        <Link to="/governance">Clinical governance</Link>{" "}
                        policy. Verification does not transfer clinical
                        responsibility to Welnido.
                    </p>

                    <h2 id="your-data" className="text-2xl">
                        5. Your data
                    </h2>

                    <p>
                        We handle personal data in line with UK GDPR and our{" "}
                        <Link to="/privacy">Privacy policy</Link>. Health
                        information you share for a booking is only shared with
                        the clinician you book.
                    </p>

                    <h2 id="liability" className="text-2xl">
                        6. Liability & disputes
                    </h2>

                    <p>
                        Clinicians are responsible for the services they
                        deliver. Welnido's liability is limited to our role as a
                        platform. Complaints can be raised via the Help centre
                        and we will always try to put things right first. These
                        terms are governed by the laws of England and Wales.
                    </p>
                </article>
            </div>
        </div>
    );
}

export default Terms;
